import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-learning-center-first-section-input',
  templateUrl: './learning-center-first-section-input.component.html',
  styleUrls: ['./learning-center-first-section-input.component.scss']
})
export class LearningCenterFirstSectionInputComponent implements OnInit {
  @Input() learningCenterForm: FormGroup;

  constructor() { }

  ngOnInit(): void {

  }

}
